import FloatRight from "../shared/FloatRight";
import FloatLeft from "../shared/FloatLeft";
import FloatUp from "../shared/FloatUp";
import Loader from "../shared/Loader";
import AppContext from "../../context/Context";
import { getEvent } from "../../context/Actions";
import { useEffect, useContext, useRef } from "react";
import { Link } from "react-router-dom";

export default function Event() {
  const { isLoading, dispatch } = useContext(AppContext);
  var currentEvent = useRef({});

  useEffect(() => {
    dispatch({ type: "SET_LOADING" });
    const getCurrentResource = async () => {
      const fetchedEvent = await getEvent(
        window.location.pathname.split("/").pop()
      );
      currentEvent.current = fetchedEvent;
      dispatch({
        type: "GET_RESOURCE",
      });
    };
    getCurrentResource();
  }, [dispatch]);

  if (isLoading) return <Loader />;

  return (
    <div className="container mb-4">
      <div className="columns">
        <div className="column is-one-third">
          <FloatRight>
            <section className="section">
              <figure className="image">
                <img
                  src={currentEvent.current.imgUrl}
                  objectFit="cover"
                  alt="Loading.."
                />
              </figure>
            </section>
          </FloatRight>
        </div>
        <div className="column">
          <FloatLeft>
            <section className="section">
              <div className="content">
                <h2 className="title is-5">{currentEvent.current.title}</h2>
                <p>{currentEvent.current.description}</p>
              </div>
            </section>
            <section className="section">
              <h2 className="title is-5">Team Details</h2>
              <p>{currentEvent.current.teamDetails}</p>
            </section>
            <section className="section has-text-centered">
              {currentEvent.current.status === "completed" ? (
                <Link to="/gallery">
                  <button className="button is-medium is-light">
                    Event Gallery
                  </button>
                </Link>
              ) : (
                <a
                  className="button is-medium is-success"
                  href={currentEvent.current.registeration}
                >
                  Register
                </a>
              )}
            </section>
          </FloatLeft>
        </div>
      </div>
      <FloatUp>
        <nav className="level mb-4" style={{ gap: "2rem" }}>
          <div className="level-item has-text-centered">
            <div>
              <p className="heading">Duration</p>
              <p className="title">{currentEvent.current.duration}</p>
            </div>
          </div>
          <div className="level-item has-text-centered mx-6">
            <div>
              <p className="heading">Date</p>
              <p className="title">{currentEvent.current.date}</p>
            </div>
          </div>
          <div className="level-item has-text-centered  mx-6">
            <div>
              <p className="heading">Start Time</p>
              <p className="title">{currentEvent.current.time}</p>
            </div>
          </div>
          <div className="level-item has-text-centered  mx-6">
            <div>
              <p className="heading">Venue</p>
              <p className="title">{currentEvent.current.venue}</p>
            </div>
          </div>
        </nav>
      </FloatUp>
    </div>
  );
}
